import { createRouter, createWebHistory } from 'vue-router'
import AuthPage from '../views/authpage/AuthPage.vue';

// 登录页是首屏，保持同步加载；其余页面仅在用户实际访问时下载。
const HomePage = () => import('../views/home/HomePage.vue')
const UserPage = () => import('../views/user/UserPage.vue')
const VideoPage = () => import('../views/video/VideoPage.vue')
const ModelPage = () => import('../views/model/ModelPage.vue')
const ReplacementPage = () => import('../views/replacement/ReplacementPage.vue')
const CreativityPage = () => import('../views/creativity/CreativityPage.vue')
const SmartPlanPage = () => import('../views/smartplan/SmartPlanPage.vue')
const OperationPage = () => import('../views/operation/OperationPage.vue')
const OperationList = () => import('../views/operationlist/OperationList.vue')
const StorePage = () => import('../views/store/StorePage.vue')
const ProductLink = () => import('../views/product/ProductLink.vue')
const ProductEdit = () => import('../views/productedit/ProductEdit.vue')
const TableImport = () => import('../views/tableimport/TableImport.vue')
const DataRecording = () => import('../views/datarecording/DataRecording.vue')
const DiagnosisPage = () => import('../views/diagnosis/DiagnosisPage.vue')
const DiagnosisContent = () => import('../views/diagnosiscontent/DiagnosisContent.vue')
const DiagnosisList = () => import('../views/diagnosislist/DiagnosisList.vue')
const DataBoard = () => import('../views/databoard/DataBoard.vue')
const TaskPage = () => import('../views/task/TaskPage.vue')
const OptimizationEngine = () => import('../views/optimization/optimizationEngine.vue')
const DetailsFission = () => import('../views/detailsfission/DetailsFission.vue')
const VideoEngine = () => import('../views/videoengine/VideoEngine.vue')
const VideoPlan = () => import('../views/videoplan/VideoPlan.vue')
const VideoStoryboard = () => import('../views/videostoryboard/VideoStoryboard.vue')
const VideoScript = () => import('../views/videoscript/VideoScript.vue')
const TasksView = () => import('../views/tasksview/TasksView.vue')
const HistoricalPage = () => import('../views/historical/HistoricalPage.vue')
const HistoricalOptimize = () => import('../views/historicaloptimize/HistoricalOptimize.vue')
const HistoricalCvr = () => import('../views/historicalcvr/HistoricalCvr.vue')
const CollectionPage = () => import('../views/collection/CollectionPage.vue')
const MyModel = () => import('../views/mymodel/MyModel.vue')
const EnterpriseData = () => import('../views/enterprisedata/EnterpriseData.vue')
const OperatingRecord = () => import('../views/operatingrecord/OperatingRecord.vue')
const FolderData = () => import('../views/folderdata/FolderData.vue')
const SharedData = () => import('../views/shareddata/SharedData.vue')
const ManagementPage = () => import('../views/management/ManagementPage.vue')
const ApplicationRecord = () => import('../views/applicationrecord/ApplicationRecord.vue')
const InviteMembers = () => import('../views/invitemembers/InviteMembers.vue')
const AboutPage = () => import('../views/about/AboutPage.vue')
const InvitationForm = () => import('../views/invitationform/InvitationForm.vue')
const ShareModel = () => import('../views/sharemodel/ShareModel.vue')
const ShareImages = () => import('../views/shareimages/ShareImages.vue')
const PowerRecords = () => import('../views/powerrecords/PowerRecords.vue')
const RechargePage = () => import('../views/recharge/RechargePage.vue')
const UserAgreement = () => import('../views/UserAgreement.vue')
const PrivacyPolicy = () => import('../views/PrivacyPolicy.vue')
const PowerRule = () => import('../views/PowerRule.vue')
const PayAgreement = () => import('../views/PayAgreement.vue')
const CsPage = () => import('../views/cs/CsPage.vue')

const routes = [{
  path: '/',
  redirect: '/user',
  // meta: { title: 'AImpress—点击率智能提升平台' }
}, {
  path: '/auth',
  name: 'AuthPage',
  component: AuthPage,
}, {
  path: '/invitationform',
  name: '邀请表单',
  component: InvitationForm,
}, {
  path: '/useragreement',
  name: '用户协议',
  component: UserAgreement,
}, {
  path: '/privacypolicy',
  name: '隐私政策',
  component: PrivacyPolicy,
}, {
  path: '/powerrule',
  name: '算力值规则',
  component: PowerRule,
}, {
  path: '/payagreement',
  name: '付费服务协议',
  component: PayAgreement,
}, {
  path: '/about',
  name: '平台介绍',
  component: AboutPage,
  meta: { title: '平台介绍-艾普AI-AImpress' }
}, {
  path: '/home',
  name: '首页',
  component: HomePage,
  // redirect: '/welcome',
  children: [
    //   {
    //   path: '/unlimited',
    //   name: '我的模型-设计',
    //   component: UnlimitedPage,
    // }, 
    {
      path: '/cs',
      name: 'CsPage',
      component: CsPage,
    },
    {
      path: '/model',
      name: '我的模型-设计',
      component: ModelPage,
      meta: { title: '我的模型-艾普AI-AImpress' }
    }, {
      path: '/replacement',
      name: '竞品替换',
      component: ReplacementPage,
      meta: { title: '竞品替换-艾普AI-AImpress' }
    }, {
      path: '/creativity',
      name: '无限创意',
      component: CreativityPage,
      meta: { title: '无限创意-艾普AI-AImpress' }
    }, {
      path: '/smart-plan',
      name: '智能对话',
      component: SmartPlanPage,
      meta: { title: '智能对话-艾普AI-AImpress' }
    }, {
      path: '/operation',
      name: '运营看板',
      component: OperationPage,
    }, {
      path: '/operationlist',
      name: '运营看板列表',
      component: OperationList,
    }, {
      path: '/store',
      name: '店铺管理',
      component: StorePage,
    }, {
      path: '/product',
      name: '产品链接管理',
      component: ProductLink,
    }, {
      path: '/productedit',
      name: '产品链接编辑',
      component: ProductEdit,
    }, {
      path: '/tableimport',
      name: '表格导入',
      component: TableImport,
    }, {
      path: '/datarecording',
      name: '数据记录',
      component: DataRecording,
    }, {
      path: '/diagnosis',
      name: '一键诊断',
      component: DiagnosisPage,
      meta: { title: '一键诊断-艾普AI-AImpress' }
    }, {
      path: '/diagnosiscontent',
      name: '一键诊断内容',
      component: DiagnosisContent,
      meta: {
        menuParent: '/diagnosis',
        menuPath: '/diagnosis',
      }
    }, {
      path: '/diagnosislist',
      name: '一键诊断列表',
      component: DiagnosisList,
      meta: {
        menuParent: '/diagnosis',
        menuPath: '/diagnosis',
      }
    }, {
      path: '/databoard',
      name: '数据看板',
      component: DataBoard,
      meta: { title: '数据看板-艾普AI-AImpress' }
    }, {
      path: '/task',
      name: '任务管理',
      component: TaskPage,
      meta: { title: '任务管理-艾普AI-AImpress' }
    }, {
      path: '/optimization',
      name: 'CTR点击优化',
      component: OptimizationEngine,
      meta: { title: 'CTR点击优化-艾普AI-AImpress' }
    }, {
      path: '/detailsfission',
      name: 'CVR详情裂变',
      component: DetailsFission,
      meta: { title: 'CVR详情裂变-艾普AI-AImpress' }
    }, {
      path: '/videoplan',
      name: 'VID视频引擎-方案',
      component: VideoPlan,
      meta: {
        menuParent: '/videoengine',
        menuPath: '/videoengine',
      }
    }, {
      path: '/videostoryboard',
      name: 'VID视频引擎-分镜',
      component: VideoStoryboard,
      meta: {
        menuParent: '/videoengine',
        menuPath: '/videoengine',
      }
    }, {
      path: '/videoscript',
      name: 'VID视频引擎-脚本',
      component: VideoScript,
      meta: {
        menuParent: '/videoengine',
        menuPath: '/videoengine',
      }
    }, {
      path: '/videoengine',
      name: 'VID视频引擎',
      component: VideoEngine,
      meta: {
        title: 'VID视频引擎-艾普AI-AImpress',
      }
    }, {
      path: '/tasksview',
      name: '查看任务',
      component: TasksView,
      meta: {
        menuParent: '/task',
        menuPath: '/task',
      }
    }, {
      path: '/historical',
      name: '历史记录',
      component: HistoricalPage,
      meta: { title: '设计记录-艾普AI-AImpress' }
    }, {
      path: '/historicaloptimize',
      name: 'CTR记录',
      component: HistoricalOptimize,
      meta: {
        title: 'CTR记录-艾普AI-AImpress',
        menuParent: '/historical',
        menuPath: '/historical',
      }
    }, {
      path: '/historicalcvr',
      name: 'CVR记录',
      component: HistoricalCvr,
      meta: {
        title: 'CVR记录-艾普AI-AImpress',
        menuParent: '/historical',
        menuPath: '/historical',
      }
    }, {
      path: '/collection',
      name: '我的收藏',
      component: CollectionPage,
      meta: { title: '我的收藏-艾普AI-AImpress' }
    }, {
      path: '/mymodel',
      name: '我的模型',
      component: MyModel,
    }, {
      path: '/enterprisedata',
      name: '企业数据',
      component: EnterpriseData,
      meta: {
        menuParent: null,  // 顶级菜单，无父级
        menuPath: '/enterprisedata',  // 高亮路径
        title: '企业数据-艾普AI-AImpress'
      }
    }, {
      path: '/operatingrecord',
      name: '企业数据-操作记录',
      component: OperatingRecord,
      meta: {
        menuParent: '/enterprisedata',
        menuPath: '/enterprisedata',
      }
    }, {
      path: '/folderdata',
      name: '文件夹数据',
      component: FolderData,
      meta: {
        menuParent: '/enterprisedata',
        menuPath: '/enterprisedata',
      }
    }, {
      path: '/shareddata',
      name: '共享数据',
      component: SharedData,
    }, {
      path: '/management',
      name: '成员管理',
      component: ManagementPage,
      meta: { title: '成员管理-艾普AI-AImpress' }
    }, {
      path: '/invitemembers',
      name: '邀请成员',
      component: InviteMembers,
      meta: {
        menuParent: '/management',
        menuPath: '/management',
      }
    }, {
      path: '/applicationrecord',
      name: '申请记录',
      component: ApplicationRecord,
      meta: {
        menuParent: '/management',
        menuPath: '/management',
      }
    }, {
      path: '/user',
      name: '个人中心',
      component: UserPage,
      meta: {
        title: '个人中心-艾普AI-AImpress',
        activeMenu: ''
      }
    }, {
      path: '/video',
      name: '视频教程',
      component: VideoPage,
      meta: { title: '视频教程-艾普AI-AImpress' }
    }, {
      path: '/sharemodel',
      name: '共享模型数据',
      component: ShareModel,
      meta: {
        activeMenu: '/shareddata' // 关键：指定高亮的菜单项 index
      }
    }, {
      path: '/shareimages',
      name: '共享产品图片',
      component: ShareImages,
      meta: {
        activeMenu: '/shareddata' // 关键：指定高亮的菜单项 index
      }
    }, {
      path: '/powerrecords',
      name: '算力值列表',
      component: PowerRecords,
      meta: {
        activeMenu: '/powerrecords'
      }
    }, {
      path: '/recharge',
      name: '算力值充值',
      component: RechargePage,
      meta: {
        activeMenu: '/recharge',
        title: '算力值充值-艾普AI-AImpress'
      }
    }]
}]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 全局后置守卫：切换路由自动更新 title（推荐用 afterEach，不阻塞导航）
router.afterEach((to) => {
  // 优先用路由 meta 里的 title，没有则用默认
  document.title = to.meta.title || '艾普AI-AImpress-为销量做设计'
})

const whitelist = ['/invitationform', '/useragreement', '/privacypolicy']
router.beforeEach((to, from, next) => {
  if (whitelist.includes(to.path)) {
    return next()
  }
  if (to.path === '/auth') return next()
  const tokenStr = localStorage.getItem('token')
  if (!tokenStr) return next('/auth')
  next()
})
// router.beforeEach((to, from, next) => {
//   // 使用 to.meta.title 获取目标路由的标题
//   if (to.meta.title) {
//     document.title = to.meta.title;
//   } else {
//     // 如果没有设置，则可以设置一个默认标题
//     document.title = '默认标题';
//   }
//   next();
// });

export default router
